export const REST_ALERT_GRACE_MS = 5000;

/** Reopening a long-expired countdown must not announce an old exercise cue. */
export function restAlertDeadline(restEndAt:string):number {
  return Date.parse(restEndAt)+REST_ALERT_GRACE_MS;
}

export function isRestAlertTimely(restEndAt:string,now=Date.now()):boolean {
  const ended=Date.parse(restEndAt);
  return Number.isFinite(ended)&&now>=ended&&now<=restAlertDeadline(restEndAt);
}
